import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addStreetAddition: 'Add address line',
    clear: 'Clear',
    ctaPrimary: 'Save',
    inputs: {
      city: {
        label: 'City',
      },
      street: {
        errors: {
          limitedLength: 'The street cannot have more than {0} characters',
        },
        label: 'Address',
        placeholder: 'Search address...',
      },
      streetAddition: {
        label: 'Address second line',
        placeholder: 'Building, stair, floor...',
      },
      zip: {
        errors: {
          invalid: 'The zip code should contain 5 digits',
        },
        label: 'Zip',
      },
    },
    subtitle:
      'Indicate your new personal address with details. Your credit card may be sent to you there in the event of renewal, loss or theft.',
    success: 'Personal address successfully changed',
    title: 'Change your personal address',
  },
  fr: {
    addStreetAddition: 'Ajouter un complément d’adresse',
    clear: 'Effacer',
    ctaPrimary: 'Enregistrer',
    inputs: {
      city: {
        label: 'Ville',
      },
      street: {
        errors: {
          limitedLength: 'La rue ne peut pas dépasser {0} caractères',
        },
        label: 'Adresse personnelle',
        placeholder: 'Rechercher votre adresse...',
      },
      streetAddition: {
        label: 'Complément d’adresse',
        placeholder: 'Batiment, escalier, étage...',
      },
      zip: {
        errors: {
          invalid: 'Le code postal doit comporter 5 chiffres',
        },
        label: 'Code postal',
      },
    },
    subtitle:
      'Indiquez votre nouvelle adresse avec précision. Votre carte bancaire sera susceptible de vous y être envoyée en cas de renouvellement, perte ou vol.',
    success: 'Adresse personnelle modifiée avec succès',
    title: 'Modifier votre adresse personnelle',
  },
} as const);

export default locales;
